module.exports = __webpack_public_path__ + "assets/media/forgetpassword_sent.da6cd5a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/FindMyTeam/FindMyTeamEmailSent/forgetpassword_sent.svg
// module id = 3074
// module chunks = 0